var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "card big-announcement" },
    [
      _vm.link
        ? _c(
            "link-to",
            { staticClass: "card__image", attrs: { to: _vm.link } },
            [
              _c("div", {
                staticClass: "cover",
                class: { no_images: _vm.isImages },
                style:
                  "background-image: url(" +
                  (this.isImages ? this.isImages : _vm.image) +
                  ");"
              })
            ]
          )
        : _c("div", { staticClass: "card__image" }, [
            _c("div", {
              staticClass: "cover",
              class: { no_images: _vm.isImages },
              style:
                "background-image: url(" +
                (this.isImages ? this.isImages : _vm.image) +
                ");"
            })
          ]),
      _c(
        "page-columns",
        {
          staticClass: "card__columns",
          attrs: { reverse: false, column_full: true }
        },
        [
          _c("template", { slot: "first" }, [
            _c("div", { staticClass: "card__content" }, [
              _vm.date
                ? _c("div", { staticClass: "card__meta" }, [
                    _c("span", {
                      staticClass: "event-date",
                      domProps: { innerHTML: _vm._s(_vm.date) }
                    })
                  ])
                : _vm._e(),
              _vm.title
                ? _c("h3", { domProps: { innerHTML: _vm._s(_vm.title) } })
                : _vm._e()
            ])
          ]),
          _c("template", { slot: "last" }, [
            _c(
              "div",
              { staticClass: "card description font-size-1" },
              [
                _vm._t("default"),
                !_vm.linkRef
                  ? _c(
                      "div",
                      {
                        staticClass: "card__actions",
                        class: { center: _vm.buttonShow }
                      },
                      [
                        _vm.more
                          ? _c(
                              "LinkTo",
                              {
                                staticClass: "text-black solid",
                                attrs: { to: _vm.link }
                              },
                              [_vm._v("Читать далее...")]
                            )
                          : _vm._e(),
                        _vm.buttonShow
                          ? _c(
                              "LinkTo",
                              {
                                staticClass: "btn solid--green large",
                                attrs: { to: _vm.link }
                              },
                              [_vm._v("Подробнее")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "card__actions",
                        class: { center: _vm.buttonShow }
                      },
                      [
                        _vm.more
                          ? _c(
                              "a",
                              {
                                staticClass: "text-black solid",
                                attrs: { href: _vm.linkRef }
                              },
                              [_vm._v("Читать далее...")]
                            )
                          : _vm._e(),
                        _vm.buttonShow
                          ? _c(
                              "a",
                              {
                                staticClass: "btn solid--green large",
                                attrs: { href: _vm.linkRef }
                              },
                              [_vm._v("Подробнее")]
                            )
                          : _vm._e()
                      ]
                    )
              ],
              2
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-359889e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-359889e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shared/sliders/NewsBigSlide.vue
// module id = 4cRs
// module chunks = 0 1 2